import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Color, Media, FontSize } from '~/utils/styles/enums';
import type { MarginsProps } from '~/utils/styles/mixins/margins';
import { Container } from './container';
import { Paper } from './paper';

export const ResultsSummary = styled.div`
  background-color: ${Color.PRIMARY};
  margin-bottom: 20px;

  @media ${Media.LARGE} {
    margin-left: 40px;
  }
`;

export const ResultsTitle = styled.h1`
  font-size: ${FontSize.SIZE_20};

  @media ${Media.MEDIUM} {
    padding-left: 20px;
  }

  @media ${Media.LARGE} {
    font-size: ${FontSize.SIZE_24};
  }
`;

export const PageWrapper = styled(Paper)`
  padding: 28px 0;
  margin-bottom: 16px;
  background-color: ${Color.PRIMARY};

  @media ${Media.LARGE} {
    padding: 40px 0;
    min-height: 70vh;
  }
`;

export const Main = styled.main<{ openInAppHeaderFixed: boolean }>`
  position: relative;

  @media ${Media.MEDIUM} {
    overflow: hidden;
  }

  ${({ openInAppHeaderFixed }) =>
    `margin-top: ${openInAppHeaderFixed ? '44px' : '0'};`}
`;

export type PageInnerProps = {
  centeredLayout?: boolean;
  unconfirmedEmail?: boolean;
  noPadding?: boolean;
  fullWidth?: boolean;
  isPreview?: boolean;
  noHeader?: boolean;
  noWidthLimit?: boolean;
  simplifiedHeader?: boolean;
  noInstallAppFooter?: boolean;
} & MarginsProps;

export const PageInner = styled(Container)<PageInnerProps>`
  display: grid;
  grid-template-columns: 100%;
  flex-grow: 1;
  width: 100%;

  @media ${Media.LARGE} {
    grid-template-columns: 1fr auto;
    margin: auto;
    ${({ noWidthLimit, isPreview }) => {
      let maxWidth = 1220;
      if (isPreview) {
        maxWidth = 730;
      } else if (noWidthLimit) {
        return 'grid-gap: 0; padding: 0; max-width: none;';
      }
      return `max-width: ${maxWidth}px;`;
    }}
    ${({ noPadding }) =>
      `grid-gap: ${noPadding ? 0 : 40}px; padding: ${noPadding ? 0 : 40}px;`}
    ${({ centeredLayout, fullWidth }) =>
      centeredLayout &&
      css`
        width: ${fullWidth ? 'auto' : '900px'};
      `};
    ${({ fullWidth }) =>
      fullWidth &&
      css`
        max-width: 1142px;
        grid-gap: 0;
      `};
    ${({ unconfirmedEmail }) =>
      unconfirmedEmail &&
      css`
        padding: 60px 40px;
      `};
  }

  ${({ isPreview }) =>
    isPreview &&
    css`
      min-width: 375px;
      max-width: 730px;
      grid-gap: 0;
    `};
`;
